import { AnimatePresence, motion } from "framer-motion";
import { CapturePackagePhotos } from "../CapturePackagePhotos";
import { useWarehouseContext } from "../WarehouseProvider";
import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Button } from "components/button";
import { ReactComponent as WarningSvg } from "../svgs/warning.svg";
import { useSteps } from "../useSteps";

export const OnPageRejectButton = () => {
  const { packagePictures } = useWarehouseContext();
  const { reject, jumpTo } = useSteps();
  const [showModal, setShowModal] = useState(false);

  const handleRejectClick = () => {
    if (packagePictures.length === 0) {
      setShowModal(true);
    } else {
      reject();
    }
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  const handleAddPhotos = () => {
    jumpTo(CapturePackagePhotos);
  };

  return (
    <>
      <button
        className="w-full rounded-lg border h-20 border-[#C12960] text-2xl bg-transparent text-[#C12960] hover:bg-[#282F44]/20 font-normal py-3.5 m-0"
        onClick={handleRejectClick}
      >
        Reject
      </button>
      {showModal &&
        createPortal(
          <AnimatePresence>
            <>
              <motion.div
                className="fixed inset-0 bg-black z-30"
                initial={{ opacity: 0 }}
                animate={{ opacity: 0.6 }}
                exit={{ opacity: 0 }}
              />
              <motion.div
                className="fixed inset-0 flex items-center justify-center z-40"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                <div className="bg-[#030711] p-6 rounded-xl shadow-lg w-full max-w-lg max-h-[95vh] overflow-auto z-20 border border-[#282F44]">
                  <div className="flex flex-row items-center gap-2 mb-4">
                    <WarningSvg
                      style={{
                        width: "32px",
                        height: "32px",
                        color: "#D8A924",
                      }}
                    />
                    <h2 className="text-[24px] text-white font-bold">
                      No Package Photo
                    </h2>
                  </div>
                  <p className="text-[18px] text-[#8086A0] font-light mb-6">
                    Please add Package Photo before rejecting the package.
                  </p>
                  <div className="flex justify-between gap-6">
                    <Button
                      onClick={handleCancel}
                      variant="secondary"
                      className="w-full border rounded-lg font-normal py-3.5 border-[#282F44] text-white bg-transparent hover:bg-[#282F44]/20"
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={handleAddPhotos}
                      className="w-full rounded-lg py-3.5 bg-[#173991] hover:bg-[#1e4bb8] text-white font-normal"
                    >
                      Add Photos
                    </Button>
                  </div>
                </div>
              </motion.div>
            </>
          </AnimatePresence>,
          document.body
        )}
    </>
  );
};
